import { collection, doc, getFirestore, setDoc } from "firebase/firestore";

import { removePopUp } from "../components/deprecated/Popup/deprecated_PopUps";
import { LockHolderData } from "../to-be-removed/LocalData/Company/LockHolderData";
import { DataCreator } from "./dataCreator";
import { t } from "i18next";
import { ToastUtilities } from "@libs/react-toastify/ToastUtilities";
import { IS_PRODUCTION } from "..";

export class Debug {
  //Turn on debug when needed, not default
  static print(...args: unknown[]) {
    if (!IS_PRODUCTION) {
      //console.log(...args);
    }
  }

  static debug(...args: unknown[]) {
    if (!IS_PRODUCTION) {
      //console.debug(...args);
    }
  }

  static log(location: string, error: any, data: any | null = null) {
    const db = getFirestore();
    const logsCollection = collection(db, "logs");

    try {
      setDoc(doc(logsCollection), {
        location: location,
        createdBy: DataCreator.getCreatedBy(),
        data: data,
        error: error,
      }).catch(() => {
        setDoc(doc(logsCollection), {
          location: location,
          createdBy: DataCreator.getCreatedBy(),
          data: data,
        });
        setDoc(doc(logsCollection), {
          location: location,
          createdBy: DataCreator.getCreatedBy(),
          error: error,
        });
      });
    } catch (error) {}
  }
  static logUnloc(location: string, lockHolder: LockHolderData | undefined, error: any, data: any | null = null) {
    if (lockHolder && error.error === "JsonWebTokenError") {
      lockHolder.scopedAuth.data = undefined;
      for (const token of lockHolder.accessTokens.documents) {
        token.deleteDocumentWithCompletionHandler(() => {});
      }

      setTimeout(() => {
        removePopUp();
        lockHolder.getScopedAuthData((token) => {
          if (token) ToastUtilities.presentSuccess(t("main.pleaseRetry"));
          else ToastUtilities.presentError(t("main.errorOccured"));
        });
      }, 250);
    }

    this.log(location, error, data);
  }
}
